import LoadingButton from '@material-ui/lab/LoadingButton';

import { styled } from '@material-ui/core/styles';

import {
    Box,
    Stack,
    MenuItem,
    TextField,
    Typography,
    Card,
    Autocomplete
} from '@material-ui/core';

// ----------------------------------------------------------------------

const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    width: 140,
    fontSize: 13,
    flexShrink: 0,
    color: theme.palette.text.secondary
}));

// ----------------------------------------------------------------------

export default function TabContactOther({ formik, fieldContact, infoContact, setCurrentTab, type, phoneNumberSelect }) {
    const { errors, touched, isSubmitting, setFieldValue, getFieldProps, values } = formik;

    const onHandleChangeOptionContactField = (itemKey, variable) =>{
        setFieldValue(variable, itemKey);
    }

    return (
        <Stack spacing={3} sx={{ px: 1.5, py: 2 }}>
            {fieldContact.length > 0 &&
                <>
                    <Typography sx={{ fontSize: '16px', fontWeight: '700', lineHeight: '20px', color: '#303187' }}>KHÁC</Typography>
                    <Card sx={{ p: 2 }}>
                        <Stack spacing={3}>
                            {fieldContact && fieldContact.map((item, index) => {
                                if (item.field_type === "text") {
                                    return (
                                        <TextField
                                            fullWidth
                                            multiline
                                            label={item.field_name}
                                            {...getFieldProps(item.field_variable)}
                                            error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                            helperText={touched[item.field_variable] && errors[item.field_variable]}
                                        />
                                    )
                                }
                                if (item.field_type === "number") {
                                    return (
                                        <TextField
                                            type='number'
                                            inputMode="numberic"
                                            fullWidth
                                            label={item.field_name}
                                            {...getFieldProps(item.field_variable)}
                                            error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                            helperText={touched[item.field_variable] && errors[item.field_variable]}
                                        />
                                    )
                                }
                                if (item.field_type === "email") {
                                    return (
                                        <TextField
                                            type='email'
                                            inputMode="email"
                                            fullWidth
                                            label={item.field_name}
                                            {...getFieldProps(item.field_variable)}
                                            error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                            helperText={touched[item.field_variable] && errors[item.field_variable]}
                                        />
                                    )
                                }
                                if (item.field_type === "phone") {
                                    return (
                                        <TextField
                                            type='tel'
                                            inputMode="tel"
                                            fullWidth
                                            label={item.field_name}
                                            {...getFieldProps(item.field_variable)}
                                            error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                            helperText={touched[item.field_variable] && errors[item.field_variable]}
                                        />
                                    )
                                }
                                if (item.field_type === "select") {
                                    return (
                                        // <TextField
                                        //     select
                                        //     fullWidth
                                        //     label={item.field_name}
                                        //     {...getFieldProps(item.field_variable)}
                                        //     error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                        //     helperText={touched[item.field_variable] && errors[item.field_variable]}
                                        // >
                                        //     {item.field_options.map((option) => {
                                        //         return (
                                        //             <MenuItem value={option.key}>{option.label}</MenuItem>
                                        //         )
                                        //     })}
                                        // </TextField>
                                        <Autocomplete
                                            key={index}
                                            id="checkboxes-tags-demo"
                                            options={item.field_options}
                                            getOptionLabel={(option) => option.label}  // Show label instead of key
                                            isOptionEqualToValue={(option, value) => option.key === value.key} // Fix selection behavior
                                            value={item.field_options.find(opt => opt.key === values[item.field_variable]) || null} // Ensure correct selection
                                            onChange={(event, newValue) => onHandleChangeOptionContactField(newValue?.key, item.field_variable)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label={item.field_name}
                                                    placeholder={item.field_name}
                                                    error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                                    helperText={touched[item.field_variable] && errors[item.field_variable]}
                                                />
                                            )}
                                        />
                                    )
                                }
                                if (item.field_type === "multiselect") {
                                    return (
                                        <TextField
                                            select
                                            fullWidth
                                            label={item.field_name}
                                            {...getFieldProps(item.field_variable)}
                                            value={Array.isArray(getFieldProps(item.field_variable).value) ? getFieldProps(item.field_variable).value : []}
                                            error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                            helperText={touched[item.field_variable] && errors[item.field_variable]}
                                            SelectProps={{
                                                multiple: true,
                                            }}
                                        >
                                            {item.field_options.map((option) => {
                                                return (
                                                    <MenuItem value={option.key}>{option.label}</MenuItem>
                                                )
                                            })}
                                        </TextField>
                                    )
                                }
                                if (item.field_type === "dateTime") {
                                    return (
                                        <TextField
                                            type="datetime-local"
                                            inputMode="numeric"
                                            fullWidth
                                            label={item.field_name}
                                            InputLabelProps={{ shrink: true }}
                                            {...getFieldProps(item.field_variable)}
                                            error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                            helperText={touched[item.field_variable] && errors[item.field_variable]}
                                        />
                                    )
                                }
                            })}
                            {!fieldContact && <Typography>Không có trường tùy chỉnh </Typography>}
                        </Stack>
                    </Card></>
            }

            <Box sx={{ mt: 3, gap: 2, display: 'flex', justifyContent: 'center' }}>
                <LoadingButton type="submit" variant="contained" loading={isSubmitting} color="secondary">
                    {Object.keys(infoContact).length === 0 || phoneNumberSelect !== infoContact.phone ? 'Tạo Liện Hệ' : 'Lưu Thay Đổi'}
                </LoadingButton>
            </Box>

        </Stack>
    );
}
